import PropTypes from "prop-types";
import React, { useContext, useEffect } from "react";
import { useNavigation } from "react-navi";

import { NaviContext } from "../contexts/navi";

export default function RedirectLayout({
  condition,
  redirectUrl,
  children: content,
}) {
  const navigation = useNavigation();
  const { context } = useContext(NaviContext);

  useEffect(() => {
    if (!navigation) {
      return;
    }
    if (!context.userLoaded) {
      return;
    }

    if (condition(context)) {
      navigation.navigate(redirectUrl);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [navigation, context, condition]);

  return (
    <React.Fragment>
      {context.userLoaded && !condition(context) && content}
    </React.Fragment>
  );
}

RedirectLayout.propTypes = {
  condition: PropTypes.func,
  redirectUrl: PropTypes.string,
  children: PropTypes.node,
};
